import appConfig from 'app-config';
import { withLocaleStaticPaths, withTranslations } from 'src/i18n/static-generation';
import AboutView from 'src/views/About';
export const getStaticPaths = withLocaleStaticPaths();
export const getStaticProps = withTranslations(() => {
  if (!appConfig.features.about.enabled) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      canonical: true,
      metas: [{
        property: 'og:title',
        content: 'OG_TITLE_ABOUT',
        key: 'og:title'
      }, {
        property: 'og:description',
        content: 'OG_DESC_ABOUT',
        key: 'og:description'
      }, {
        name: 'description',
        content: 'OG_DESC_ABOUT',
        key: 'description'
      }, {
        property: 'og:image',
        content: `/${appConfig.serviceCode}/images/og/openGraph.png`,
        key: 'og:image'
      }]
    }
  };
}, {
  xDefaultRouteFn: () => ({
    pathname: '/about'
  })
});
export default function Page() {
  if (!appConfig.features.about.enabled) {
    return null;
  }
  return <AboutView data-sentry-element="AboutView" data-sentry-component="Page" data-sentry-source-file="about.tsx" />;
}